import { createSignal } from 'solid-js';

const STORAGE_PREFIX = 'chorepop:hidden-family-content:';
const [viewerAccountId, setViewerAccountId] = createSignal<number | null>(null);
const [hiddenIds, setHiddenIds] = createSignal<ReadonlySet<string>>(new Set());

function storageKey(accountId: number): string {
  return `${STORAGE_PREFIX}${accountId}`;
}

function readHidden(accountId: number): ReadonlySet<string> {
  try {
    const raw = localStorage.getItem(storageKey(accountId));
    if (!raw) return new Set<string>();
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed)
      ? new Set(parsed.filter((value): value is string => typeof value === 'string'))
      : new Set<string>();
  } catch {
    return new Set<string>();
  }
}

export function setFamilyContentViewer(accountId: number | null): void {
  setViewerAccountId(accountId);
  setHiddenIds(accountId === null ? new Set<string>() : readHidden(accountId));
}

export function isFamilyContentHidden(contentLocalId: string): boolean {
  return hiddenIds().has(contentLocalId);
}

export function hideFamilyContent(contentLocalId: string): void {
  const accountId = viewerAccountId();
  if (accountId === null) throw new Error('Sign in again before hiding family content.');
  const next = new Set(hiddenIds());
  next.add(contentLocalId);
  setHiddenIds(next);
  localStorage.setItem(storageKey(accountId), JSON.stringify([...next].sort()));
}

export function restoreHiddenFamilyContent(contentLocalId: string): void {
  const accountId = viewerAccountId();
  if (accountId === null) return;
  const next = new Set(hiddenIds());
  next.delete(contentLocalId);
  setHiddenIds(next);
  localStorage.setItem(storageKey(accountId), JSON.stringify([...next].sort()));
}

export function clearAllFamilyContentVisibility(): void {
  for (let index = localStorage.length - 1; index >= 0; index -= 1) {
    const key = localStorage.key(index);
    if (key?.startsWith(STORAGE_PREFIX)) localStorage.removeItem(key);
  }
  setFamilyContentViewer(null);
}
